import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDiamond, 
  faGem, 
  faScroll, 
  faHashtag, 
  faCoins, 
  faBirthdayCake, 
  faSignature, 
  faQuestion,
  faStar,
  faMapMarkerAlt,
  faMoon,
  faClock,
  faRotate,
  faSun
} from '@fortawesome/free-solid-svg-icons';

const CategoryGrid = () => {
  const tools = [
    {
      title: "Birth Chart",
      path: "/birthchart",
      icon: faStar,
      description: "Generate your complete birth chart",
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      title: "Ascendant Calculator",
      path: "/ascendant", 
      icon: faMapMarkerAlt,
      description: "Calculate your rising sign",
      color: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
    },
    {
      title: "Moon Phase",
      path: "/moonphase",
      icon: faMoon,
      description: "Calculate moon phases for any date",
      color: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    },
    {
      title: "Planetary Hours",
      path: "/planetaryhours",
      icon: faClock,
      description: "Calculate planetary hours for timing",
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      title: "Tarot Card",
      path: "/tools/randomtarotcard",
      icon: faScroll,
      description: "Draw a card for guidance",
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      title: "Celtic Cross",
      path: "/tools/celticcross",
      icon: faScroll,
      description: "Complete 10-card tarot spread",
      color: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
    },
    {
      title: "Rune",
      path: "/tools/randomrune", 
      icon: faGem,
      description: "Ancient Norse wisdom",
      color: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
    },
    {
      title: "Playing Card",
      path: "/tools/randomplayingcard",
      icon: faDiamond,
      description: "Classic card divination",
      color: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
    },
    {
      title: "Number",
      path: "/tools/randomnumber",
      icon: faHashtag,
      description: "Numerical insights",
      color: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    {
      title: "Coin Flipper",
      path: "/tools/randomcoinflipper",
      icon: faCoins,
      description: "Simple yes or no",
      color: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    },
    {
      title: "Birthday Numerology",
      path: "/tools/numerologycalculator",
      icon: faBirthdayCake,
      description: "Life path numbers",
      color: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)"
    },
    {
      title: "Name Numerology",
      path: "/tools/numerologyname",
      icon: faSignature,
      description: "Name significance",
      color: "linear-gradient(135deg, #a8caba 0%, #5d4e75 100%)"
    },
    {
      title: "Yes or No",
      path: "/tools/yesorno",
      icon: faQuestion,
      description: "Quick decisions",
      color: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)"
    },
    {
      title: "Retrogrades",
      path: "/retrogrades",
      icon: faRotate,
      description: "Check planetary retrogrades",
      color: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    },
    {
      title: "Solar Return",
      path: "/solarreturn",
      icon: faSun,
      description: "Annual birthday chart",
      color: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)"
    },
    {
      title: "Saturn Return",
      path: "/saturnreturn",
      icon: faSun,
      description: "Find your Saturn return date and chart",
      color: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)"
    },
    {
      title: "Lunar Return",
      path: "/lunarreturn",
      icon: faMoon,
      description: "Find your lunar return date and chart",
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      title: "Transit Dashboard",
      path: "/transits",
      icon: faStar,
      description: "View current planetary transits and their impact",
      color: "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)"
    }
  ];

  return (
    <div className="section" style={{ 
      padding: '4rem 0',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center'
    }}>
      <div className="container">
        <div className="columns is-multiline is-centered">
          {tools.map((tool, index) => (
            <div key={index} className="column is-3-desktop is-4-tablet is-6-mobile" style={{ padding: '0.75rem' }}>
              <Link to={tool.path} style={{ textDecoration: 'none' }}>
                <div className="tool-card" style={{
                  background: 'rgba(25, 25, 25, 0.8)',
                  borderRadius: '16px',
                  padding: '2rem 1.5rem',
                  height: '280px',
                  border: '2px solid rgba(255, 215, 0, 0.2)',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}>
                  {/* Gradient overlay */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: tool.color,
                    opacity: 0.1,
                    borderRadius: '16px',
                    transition: 'opacity 0.3s ease'
                  }} />
                  
                  {/* Icon */}
                  <div style={{
                    position: 'relative',
                    zIndex: 2,
                    marginBottom: '1.5rem',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: tool.color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
                    transition: 'all 0.3s ease'
                  }}>
                    <FontAwesomeIcon 
                      icon={tool.icon} 
                      style={{ 
                        color: 'white', 
                        fontSize: '1.5rem',
                        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
                      }} 
                    />
                  </div>

                  {/* Title */}
                  <h3 className="title" style={{
                    color: '#FFD700',
                    fontSize: '1.2rem',
                    fontWeight: 600,
                    marginBottom: '0.75rem',
                    textAlign: 'center',
                    position: 'relative',
                    zIndex: 2,
                    transition: 'color 0.3s ease'
                  }}>
                    {tool.title}
                  </h3>

                  {/* Description */}
                  <p style={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '0.9rem',
                    textAlign: 'center',
                    lineHeight: '1.4',
                    position: 'relative',
                    zIndex: 2,
                    transition: 'color 0.3s ease'
                  }}>
                    {tool.description}
                  </p>

                  {/* Hover effects */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(135deg, rgba(255, 215, 0, 0.1), rgba(255, 165, 0, 0.1))',
                    borderRadius: '16px',
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                    pointerEvents: 'none'
                  }} />
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryGrid;
